import React from 'react'
import ActiveUsers from 'pages/admin/components/ActiveUsers'

const AdminActiveUsers = () => {
  return (
    <div className="w-full min-h-screen px-4 bg-white py-4 md:px-10">
      <ActiveUsers />
    </div>
  )
}

export default AdminActiveUsers
